export const iconVariables = {
  LINE_HEIGHT_REGULAR: '1',
  LINE_HEIGHT_INHERIT: 'inherit',
  SIZE_XS: '16px',
  SIZE_S: '20px',
  SIZE_M: '24px',
  SIZE_L: '28px',
  SIZE_XL: '36px'
};
